<div class="tabs dashboard-component-tabs is-boxed is-small is-marginless">
  <ul>
    <li class="is-active">
      <a><span i18n>Search</span></a>
    </li>
  </ul>
</div>


<div class="control has-icons-left has-icons-right">
  <input class="input is-small input-search" type="text" [(ngModel)]="objectIDsString"
    placeholder="Enter plot IDs...,e.g. 1111111;2222222;3333333 " i18n-placeholder="Enter plot IDs..."
    (ngModelChange)="setObjectIDsString($event)">
  <span class="icon is-small is-left">
    <i-feather name="search" class="icon-smaller"></i-feather>
  </span>
  <div class="search-footer right-align has-shadow">
    @if (!loading) {
      <button class="button is-light is-small" (click)="requestPlots()" [disabled]="filters.id.length === 0">
        <strong i18n>Apply filters</strong>
      </button>
    } @else {
      <button  class="button is-light is-small" disabled>
        <div class="loader"></div>&nbsp;
        <strong i18n>Apply filters</strong>
      </button>
    }
    &nbsp;
    <button class="button is-light is-small" (click)="resetFilters()" [disabled]="loading || objectIDsString.length === 0">
      <ng-container i18n>Reset filters</ng-container>
    </button>
  </div>
</div>

<div class="search-results">
  @if (plotIDs && plotIDs.length > 0 && !loading) {
    <div class="message is-small">
      <div class="columns">
        <div class="column is-italic">
          <div class="scrollable-list">
            <span i18n>Found following plots and added them to Dashboard:</span>
            @for (id of plotIDs; track id; let i = $index) {
              <span style="user-select: text;">
                {{id}}@if ((i + 1) % 5 === 0) {
                <br>
                }
              </span>
            }
          </div>
        </div>
      </div>
    </div>
  }

  @if (notFoundIDs && notFoundIDs.length > 0 && !loading) {
    <div class="message is-small">
      <div class="columns">
        <div class="column is-italic has-text-danger">
          <div class="scrollable-list">
            <span i18n>Following plot IDs could not be found:</span>
            @for (id of notFoundIDs; track id; let i = $index) {
              <span style="user-select: text;">
                {{id}}@if ((i + 1) % 5 === 0) {
                <br>
                }
              </span>
            }
          </div>
        </div>
      </div>
    </div>
  }
</div>
